import { useState } from "react";
import { Checkbox, Group } from "@mantine/core";

import classes from './CheckboxButton.module.css';

interface CheckboxButtonProps {
  label: string;
  checked?: boolean;
  onChange?: Function;
}

export default function CheckboxButton({
  label,
  checked = false,
  onChange
}: CheckboxButtonProps) {
  const [value, setValue] = useState(checked);
  
  return (
    <Checkbox.Card
      className={classes.root}
      checked={value}
      radius="md"
      p={8}
      w="initial"
      onClick={() => {
        const newValue = !value;
        setValue(newValue)
        onChange && onChange(newValue);
      }}
    >
      <Group wrap="nowrap" align="center">
        <Checkbox.Indicator />
        <div>{label}</div>
      </Group>
    </Checkbox.Card>
  );
}
